/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Title1Inputs */

const id_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway dalam Angka`)
};

const ms_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberian dalam Angka`)
};

const da_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways i tal`)
};

const de_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways in Zahlen`)
};

const en_us2_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways in numbers`)
};

const es_es2_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos en números`)
};

const es_mx2_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos en números`)
};

const fil_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway sa numero`)
};

const fr_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les gratuités en chiffres`)
};

const it_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway in numeri`)
};

const hu_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajándékok számokban`)
};

const nl_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways in cijfers`)
};

const no_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways i tall`)
};

const pl_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozdania w liczbach`)
};

const pt_br2_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways in numbers`)
};

const pt_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas grátis em números`)
};

const ro_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte gratuite în cifre`)
};

const fi_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaisjaot numeroina`)
};

const sv_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utlottningar i siffror`)
};

const vi_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tặng miễn phí qua số liệu`)
};

const tr_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayılarla Bedava Oyunlar`)
};

const cs_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výprodeje v číslech`)
};

const bg_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатните игри в числа`)
};

const ru_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раздачи в цифрах`)
};

const uk_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роздачі в цифрах`)
};

const ar_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهدايا بالأرقام`)
};

const hi_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गिवअवे आँकड़े`)
};

const th_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ของแจกฟรีในตัวเลข`)
};

const ja_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字で見る配布`)
};

const zh_cn2_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways in numbers`)
};

const zh_hant1_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways in numbers`)
};

const ko_components_giveawaystats_title1 = /** @type {(inputs: Components_Giveawaystats_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaways in numbers`)
};

/**
* | output |
* | --- |
* | "Giveaways in numbers" |
*
* @param {Components_Giveawaystats_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_title1 = /** @type {((inputs?: Components_Giveawaystats_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_title1(inputs)
	if (locale === "ms") return ms_components_giveawaystats_title1(inputs)
	if (locale === "da") return da_components_giveawaystats_title1(inputs)
	if (locale === "de") return de_components_giveawaystats_title1(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_title1(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_title1(inputs)
	if (locale === "fil") return fil_components_giveawaystats_title1(inputs)
	if (locale === "fr") return fr_components_giveawaystats_title1(inputs)
	if (locale === "it") return it_components_giveawaystats_title1(inputs)
	if (locale === "hu") return hu_components_giveawaystats_title1(inputs)
	if (locale === "nl") return nl_components_giveawaystats_title1(inputs)
	if (locale === "no") return no_components_giveawaystats_title1(inputs)
	if (locale === "pl") return pl_components_giveawaystats_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_title1(inputs)
	if (locale === "pt") return pt_components_giveawaystats_title1(inputs)
	if (locale === "ro") return ro_components_giveawaystats_title1(inputs)
	if (locale === "fi") return fi_components_giveawaystats_title1(inputs)
	if (locale === "sv") return sv_components_giveawaystats_title1(inputs)
	if (locale === "vi") return vi_components_giveawaystats_title1(inputs)
	if (locale === "tr") return tr_components_giveawaystats_title1(inputs)
	if (locale === "cs") return cs_components_giveawaystats_title1(inputs)
	if (locale === "bg") return bg_components_giveawaystats_title1(inputs)
	if (locale === "ru") return ru_components_giveawaystats_title1(inputs)
	if (locale === "uk") return uk_components_giveawaystats_title1(inputs)
	if (locale === "ar") return ar_components_giveawaystats_title1(inputs)
	if (locale === "hi") return hi_components_giveawaystats_title1(inputs)
	if (locale === "th") return th_components_giveawaystats_title1(inputs)
	if (locale === "ja") return ja_components_giveawaystats_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_title1(inputs)
	return ko_components_giveawaystats_title1(inputs)
});
export { components_giveawaystats_title1 as "components.giveawayStats.title" }